import {
  LineStatus,
  MediaType,
  OrderType,
  SourceSystem
} from './enums';
import { CompressedErrorMessageIndex } from './compressed-error-message-index';
import { OrderShipment } from './order-shipment';
import { ErrorMessage } from './error-message';
import { CompressedOrderShipmentGroupsList } from './compressed-order-shipment-groups-list';

export class CompressedOrderShipment {
  orderNumber: number;
  customerNumber: number;
  shipmentNumber: number;
  shipDate: Date;
  needDate: Date;
  orderType: OrderType;
  status: LineStatus;
  hasError: boolean;
  allLinesAreCancelled: boolean;
  customerName: string;
  drmTypeIndex: number;
  accountExecutiveIndex: number;
  errors: CompressedErrorMessageIndex[];
  mediaType: MediaType;
  sourceSystem: SourceSystem;
  portalId?: string;
  marketSalesDivision?: string;
  marketOrgType?: string;
  uploadShipmentToNetworkShare: boolean;
  isOrderProcessing?: boolean;
  shipmentStatus: string;
  orderSourceSystem: number;

  constructor() {
    this.orderNumber = null;
    this.customerNumber = null;
    this.shipmentNumber = 1;
    this.shipDate = new Date();
    this.needDate = new Date();
    this.orderType = OrderType.Unknown;
    this.status = LineStatus.Pending;
    this.hasError = true; // this will help show on orders listing by default
    this.allLinesAreCancelled = false;
    this.drmTypeIndex = -1;
    this.accountExecutiveIndex = -1;
    this.errors = [];
    this.mediaType = MediaType.Unknown;
    this.sourceSystem = SourceSystem.Sgc;
    this.portalId = null;
    this.marketOrgType = '';
    this.marketSalesDivision = '';
    this.uploadShipmentToNetworkShare = false;
    this.isOrderProcessing = false;
    this.shipmentStatus = '';
    this.orderSourceSystem = null;
  }

  /**
   * Convert a CompressedOrderShipment to an OrderShipment for use in the rest of Insight.
   * @param compressedOrderShipmentGroupsList The CompressedOrderShipmentGroupsList that this CompressedOrderShipment belongs to.
   * @param compressedShipment The CompressedOrderShipment.
   * @returns The OrderShipment.
   */
  static toOrderShipment(compressedOrderShipmentGroupsList: CompressedOrderShipmentGroupsList, compressedShipment: CompressedOrderShipment): OrderShipment {
    let orderShipment = new OrderShipment();
    orderShipment.orderNumber = compressedShipment.orderNumber;
    orderShipment.customerNumber = compressedShipment.customerNumber;
    orderShipment.shipmentNumber = compressedShipment.shipmentNumber;
    orderShipment.shipDate = compressedShipment.shipDate;
    orderShipment.needDate = compressedShipment.needDate;
    orderShipment.orderType = compressedShipment.orderType;
    orderShipment.status = compressedShipment.status;
    orderShipment.hasError = compressedShipment.hasError;
    orderShipment.allLinesAreCancelled = compressedShipment.allLinesAreCancelled;
    orderShipment.customerName = compressedOrderShipmentGroupsList.allCustomers[compressedShipment.customerNumber];
    orderShipment.drmType = (compressedShipment.drmTypeIndex === -1) ? '' : compressedOrderShipmentGroupsList.allDrmTypes[compressedShipment.drmTypeIndex];
    orderShipment.accountExecutive = (compressedShipment.accountExecutiveIndex === -1) ? '' : compressedOrderShipmentGroupsList.allAccountExecutives[compressedShipment.accountExecutiveIndex];
    orderShipment.mediaType = compressedShipment.mediaType;
    orderShipment.sourceSystem = compressedShipment.sourceSystem;
    orderShipment.portalId = compressedShipment.portalId;
    orderShipment.marketOrgType = compressedShipment.marketOrgType;
    orderShipment.marketSalesDivision = compressedShipment.marketSalesDivision;
    orderShipment.uploadShipmentToNetworkShare = compressedShipment.uploadShipmentToNetworkShare;
    orderShipment.isOrderProcessing = compressedShipment.isOrderProcessing;
    orderShipment.shipmentStatus = compressedShipment.shipmentStatus;
    orderShipment.orderSourceSystem = compressedShipment.orderSourceSystem;

    // Map the errors based on the error indexes
    compressedShipment.errors.map((errorIndex: CompressedErrorMessageIndex) => {
      let foundError = compressedOrderShipmentGroupsList.allErrors[errorIndex.index];
      orderShipment.errors.push(new ErrorMessage(
        foundError.message,
        errorIndex.time,
        foundError.type,
        foundError.errorName,
        errorIndex.line,
        foundError.simpleMessage
      ));
    });

    return orderShipment;
  }
}
